import type { ApiError } from "./client";

/**
 * Extracts a human-readable message from a rejected SDK call.
 *
 * SDK calls reject with an `ApiError` (`{ status, body }`), NOT an `Error`, so
 * `err instanceof Error` is always false and `err.message` is undefined. FastAPI
 * puts the useful text in `body.detail` (e.g. a 409's "A contact with this email
 * already exists."); fall back to `fallback` when it's missing or non-string.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const body = (err as ApiError | null)?.body;
  if (body && typeof body === "object" && "detail" in body) {
    const detail = (body as { detail?: unknown }).detail;
    if (typeof detail === "string" && detail.trim()) {
      return detail;
    }
  }
  return fallback;
}
